import React, { useState } from 'react';
import DateNumberBody from '../DateNumberBody/DateNumberBody';
import { ReactComponent as CalendarDateIcon } from '../../../../resource/CalendarDateIcon.svg';
import Card from '../Card/Card';

const DateNumberContainer = ({ form }) => {
  const [expanded, setExpanded] = useState(true);

  const handleExpanded = () => {
    setExpanded(!expanded);
  };

  return (
    <Card
      heading="Дата и номера"
      icon={<CalendarDateIcon />}
      expanded={expanded}
      handleExpanded={handleExpanded}
    >
      <DateNumberBody form={form} />
    </Card>
  );
};

export default DateNumberContainer;
